import { useState, useEffect } from 'react';

export default function Leaderboard() {
  const [iframeHeight, setIframeHeight] = useState(600);

  useEffect(() => {
    const updateHeight = () => {
      if (window.innerWidth < 640) {
        setIframeHeight(900);
      } else if (window.innerWidth < 1024) {
        setIframeHeight(1200);
      } else {
        setIframeHeight(1600);
      }
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <section id="leaderboard" className="relative py-10 sm:py-24 bg-[#0A1628]">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        {/* Image Section */}
        <div className="flex justify-center mb-5 sm:mb-8">
          <img
            src="https://static.readdy.ai/image/227cab682d83965c949f1d2451ee4e6c/efc9632cfe0f8ea0b97c5c1db5230ece.png"
            alt="참여 안내"
            className="w-full max-w-[180px] sm:max-w-[250px] h-auto rounded-lg"
          />
        </div>

        {/* Description Box */}
        <div className="mb-6 sm:mb-12 p-3 sm:p-6 border border-[#D4AF37]/30 sm:border-2 rounded-lg bg-[#0A1628]/50 backdrop-blur-sm">
          <ul className="space-y-1.5 sm:space-y-2 text-white/80 text-xs sm:text-base">
            <li className="flex items-start gap-1.5 sm:gap-2">
              <span className="text-[#D4AF37] mt-0.5 sm:mt-1 flex-shrink-0">•</span>
              <span className="text-amber-300 font-semibold leading-relaxed">
                [안내] 2월 19일 오전11:00 이전 참여자분들께 드리는 확인 요청<br />
                <span className="text-white/80 font-normal">
                  2월 19일(목) 오전 11시 이전에 참여하신 분들은 오픈채팅 QR로 저에게 &quot;19일 이전 참여자입니다&quot;라고 톡 한 번만 주세요!
                </span>
              </span>
            </li>
            <li className="flex items-start gap-1.5 sm:gap-2">
              <span className="text-[#D4AF37] mt-0.5 sm:mt-1 flex-shrink-0">•</span>
              <span>문의사항 있을 시 카톡 오픈 채팅방에서 문의 해주세요</span>
            </li>
          </ul>
        </div>

        {/* 보상 산식 수정 공지 */}
        <div className="mb-6 sm:mb-12 p-4 sm:p-6 border border-[#D4AF37]/50 sm:border-2 rounded-lg bg-gradient-to-r from-[#D4AF37]/10 to-[#0A1628]/50 backdrop-blur-sm">
          <div className="flex items-center gap-2 mb-3 sm:mb-4">
            <span className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-[#D4AF37] text-sm sm:text-base">
              <i className="ri-megaphone-line"></i>
            </span>
            <h3 className="text-sm sm:text-lg font-bold text-[#D4AF37]">[보상 산식 수정 공지]</h3>
          </div>
          <div className="space-y-2.5 sm:space-y-3 text-white/85 text-xs sm:text-base leading-relaxed">
            <p>
              기존 산식에서 소량·단기 참여가 대량·장기 참여보다 높게 측정되는 점수 역전 현상(예: 0.5모 30일 &gt; 1모 365일)이 확인되었습니다.
            </p>
            <p>
              이에 따라 <strong className="text-[#D4AF37] font-semibold">수량과 기간에 비례한 공정한 보상</strong>이 이루어지도록 산식을 <strong className="text-[#D4AF37] font-semibold">0.48승</strong>으로 조정합니다.
            </p>
            <p className="text-white/60 text-[10px] sm:text-sm">
              기여도에 걸맞은 보상을 위한 조치이오니 양해 부탁드립니다.
            </p>
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-6 sm:mb-16">
          <h2 className="text-lg sm:text-3xl lg:text-4xl font-bold text-white mb-1.5 sm:mb-3">실시간 순위표</h2>
          <p className="text-[10px] sm:text-base text-gray-400 mb-2 sm:mb-3 px-2">
            데이터 반영까지 최대 15~20분 소요될 수 있습니다.
          </p>
          <div className="flex justify-center">
            <div className="w-10 sm:w-20 lg:w-24 h-0.5 bg-[#D4AF37]"></div>
          </div>
        </div>

        {/* Looker Studio Dashboard */}
        <div className="w-full bg-[#1A2332] rounded-lg sm:rounded-xl overflow-hidden -mx-0.5 sm:mx-0">
          {/* iframe is not a void element; must have a closing tag in JSX */}
          <iframe
            width="100%"
            height={iframeHeight}
            src="https://lookerstudio.google.com/embed/reporting/8607857d-e13b-4ca2-b60b-82826fa8f8d0/page/qIhoF"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
